module.exports = new __parcel__URL__("list-merge-spotlight-dark.79a7436a.gif").toString();